import {defineMessages} from 'react-intl'

export const priceTrendMessages = defineMessages({
  recommendationCheaperThanSimilar: {
    id: 'pricesCheaperThanSimilarHotels',
    defaultMessage: 'Prices are cheaper than similar hotels'
  },
  recommendationHigherThanSimilar: {
    id: 'pricesHigherThanSimilarHotels',
    defaultMessage: 'Prices are higher than similar hotels'
  },
  recommendationPricesDropped: {
    id: 'pricesDropped',
    defaultMessage: 'Prices have dropped'
  },
  recommendationPricesStable: {
    id: 'pricesStable',
    defaultMessage: 'Prices have been stable'
  },
  recommendationPricesIncreased: {
    id: 'pricesIncreased',
    defaultMessage: 'Prices have increased'
  },
  recommendationTypicalInArea: {
    id: 'pricesTypicalInArea',
    defaultMessage: 'Prices are typical in the area'
  },
  hotelChangeNoChange: {
    id: 'noChangeInPrice',
    defaultMessage: 'No change in price'
  },
  hotelChangePriceUp: {
    id: 'pricesUpPercent',
    defaultMessage: 'Prices up {percent}%'
  },
  hotelChangePriceDown: {
    id: 'pricesDownPercent',
    defaultMessage: 'Prices down {percent}%'
  },
  hotelChangeSubtitle: {
    id: 'vsLastTimeRangeDays',
    defaultMessage:
      'vs. {timeRange, plural, one {the last day} other {the last # days}}'
  },
  hotelChangeTooltip: {
    id: 'comparedToHotelsAverageLastTimeRangeDays',
    defaultMessage:
      "Compared to this hotel's average price {lastDays, plural, one {over the last day} other {over the last # days}}"
  },
  similarHotelsNoDifference: {
    id: 'noPriceDifference',
    defaultMessage: 'No price difference'
  },
  similarHotelsCheaper: {
    id: 'percentCheaper',
    defaultMessage: '{percent}% cheaper'
  },
  similarHotelsMoreExpensive: {
    id: 'percentMoreExpensive',
    defaultMessage: '{percent}% more expensive'
  },
  similarHotelsSubtitle: {
    id: 'vsSimilarHotels',
    defaultMessage: 'vs. similar hotels'
  },
  similarHotelsDescription: {
    id: 'similarHotelsDescription',
    defaultMessage:
      'Similar hotels are hotels in the same area with similar star rating, guest reviews, and amenities.'
  },
  freezeDealsFromValue: {
    id: 'freezeDealsFromValue',
    defaultMessage: 'Freeze deals from {value}'
  },
  viewRoomsFromValue: {
    id: 'viewRoomsFromValue',
    defaultMessage: 'View rooms from {value}'
  },
  viewDealFromValue: {
    id: 'viewDealFromValue',
    defaultMessage: 'View deal from {value}'
  },
  priceHistory: {
    id: 'priceHistory',
    defaultMessage: 'Price history'
  },
  priceHistoryNow: {
    id: 'now',
    defaultMessage: 'Now'
  },
  priceHistoryDaysAgo: {
    id: 'daysAgo',
    defaultMessage: '{daysAgo, plural, one {# day ago} other {# days ago}}'
  },
  priceHistoryDaysAgoLabel: {
    id: 'pastDaysInsight',
    defaultMessage: '{days} days ago'
  },
  priceHistoryThisHotel: {
    id: 'thisHotel',
    defaultMessage: 'This hotel'
  },
  priceHistorySimilarHotels: {
    id: 'similarHotels',
    defaultMessage: 'Similar hotels'
  },
  betterValueStaysIn: {
    id: 'betterValueStaysIn',
    defaultMessage: 'Better value stays in {city}'
  },
  seeMore: {
    id: 'seeMore',
    defaultMessage: 'See more'
  },
  insightsTooltip: {
    id: 'priceInsightsTooltip',
    defaultMessage:
      'See the price history of this stay and similar options nearby.'
  },
  priceInsightsBannerCheaper: {
    id: 'priceInsightsBannerCheaper',
    defaultMessage: '{percent}% cheaper than similar hotels'
  },
  priceInsightsBannerFair: {
    id: 'priceInsightsBannerFair',
    defaultMessage: 'Fair price vs similar hotels'
  },
  priceInsightsBannerAlternatives: {
    id: 'priceInsightsBannerAlternatives',
    defaultMessage: 'Better value options nearby'
  },
  priceInsightsBannerLoading: {
    id: 'priceInsightsBannerLoading',
    defaultMessage: 'Analysing deal...'
  },
  priceInsightsBannerNoData: {
    id: 'priceInsightsBannerNoData',
    defaultMessage: 'Best available deal'
  },
  priceInsightsDealscoreSegmentLow: {
    id: 'priceInsightsDealscoreSegmentLow',
    defaultMessage: 'Low price'
  },
  priceInsightsDealscoreSegmentFair: {
    id: 'priceInsightsDealscoreSegmentFair',
    defaultMessage: 'Fair price'
  },
  priceInsightsDealscoreSegmentHigh: {
    id: 'priceInsightsDealscoreSegmentHigh',
    defaultMessage: 'High price'
  },
  priceInsightsDealscoreFooterLabel: {
    id: 'priceInsightsDealscoreFooterLabel',
    defaultMessage: 'Price compared to similar hotels nearby.'
  },
  priceInsightsDealscoreSimilarHotelsTooltip: {
    id: 'priceInsightsDealscoreSimilarHotelsTooltip',
    defaultMessage:
      'Similar hotels near this hotel, with comparable star ratings, guest reviews and amenities.'
  },
  // --- "Our advice" panel (Price Insights v4, mobile web A/B) ---
  // Headers
  priceInsightsAdviceHeader: {
    id: 'priceInsightsAdviceHeader',
    defaultMessage: 'Our advice'
  },
  priceInsightsSummaryHeader: {
    id: 'priceInsightsSummaryHeader',
    defaultMessage: 'Insights summary'
  },
  // Verdict headlines
  priceInsightsAdviceGoodTimeToBook: {
    id: 'priceInsightsAdviceGoodTimeToBook',
    defaultMessage: 'Good time to book'
  },
  priceInsightsAdviceConsiderAlternatives: {
    id: 'priceInsightsAdviceConsiderAlternatives',
    defaultMessage: 'Consider alternatives'
  },
  priceInsightsAdviceFreezeHeadline: {
    id: 'priceInsightsAdviceFreezeHeadline',
    defaultMessage: 'Freeze a deal'
  },
  priceInsightsAdviceFreeBadge: {
    // Reuses the Refreeze rollout's already-translated key (Apr 2026 order).
    id: 'dealFreeze.bannerFreeTag',
    defaultMessage: 'Free'
  },
  // Reason statements A: similar-hotels band
  priceInsightsAdviceCheaperThanSimilar: {
    id: 'priceInsightsAdviceCheaperThanSimilar',
    defaultMessage: '{percent}% cheaper than similar hotels nearby'
  },
  priceInsightsAdviceMoreExpensiveThanSimilar: {
    id: 'priceInsightsAdviceMoreExpensiveThanSimilar',
    defaultMessage: '{percent}% more expensive than similar hotels'
  },
  priceInsightsAdviceCloseToSimilar: {
    id: 'priceInsightsAdviceCloseToSimilar',
    defaultMessage: 'Price is close to similar hotels'
  },
  priceInsightsAdviceNoSimilarHotels: {
    id: 'priceInsightsAdviceNoSimilarHotels',
    defaultMessage: 'No similar hotels nearby'
  },
  // Reason statements B: this hotel's own trend
  priceInsightsAdvicePriceDropped: {
    id: 'priceInsightsAdvicePriceDropped',
    defaultMessage: 'Price has dropped by {percent}% recently'
  },
  priceInsightsAdvicePriceRising: {
    id: 'priceInsightsAdvicePriceRising',
    defaultMessage: 'Price has risen by {percent}% recently'
  },
  priceInsightsAdvicePriceNotChanged: {
    id: 'priceInsightsAdvicePriceNotChanged',
    defaultMessage: 'Price has not changed much recently'
  },
  // Reason statements D: days until check-in
  priceInsightsAdviceDaysUntilCheckIn: {
    id: 'priceInsightsAdviceDaysUntilCheckIn',
    defaultMessage:
      '{days, plural, one {# day until check-in} other {# days until check-in}}'
  },
  // Reason statements C: this hotel vs market trend
  priceInsightsAdviceRisingFasterThanMarket: {
    id: 'priceInsightsAdviceRisingFasterThanMarket',
    defaultMessage: 'Prices have risen faster than the market.'
  },
  // DealScore comparison-bar headings
  priceInsightsAdviceBarHeadingLow: {
    id: 'priceInsightsAdviceBarHeadingLow',
    defaultMessage: 'Cheaper than similar hotels'
  },
  priceInsightsAdviceBarHeadingHigh: {
    id: 'priceInsightsAdviceBarHeadingHigh',
    defaultMessage: 'High price vs. similar options'
  },
  // Sticky bottom-bar helper subtitles
  priceInsightsAdviceHelperFreeze: {
    id: 'priceInsightsAdviceHelperFreeze',
    defaultMessage: "Secure today's price while you decide."
  },
  priceInsightsAdviceHelperAlternatives: {
    id: 'priceInsightsAdviceHelperAlternatives',
    defaultMessage: 'Compare similar stays before you decide.'
  },
  // Deal-freeze explainer link + tooltip
  priceInsightsDealFreezeExplainerLink: {
    id: 'priceInsightsDealFreezeExplainerLink',
    defaultMessage: 'What is Deal Freeze?'
  },
  priceInsightsDealFreezeExplainerBody: {
    // Reuses the Refreeze rollout's already-translated key (Apr 2026 order);
    // the ordered English is identical to this explainer body.
    id: 'dealFreeze.bannerSubtitleRefreeze',
    defaultMessage:
      "Guarantee the room and price while you decide. If prices drop, we'll refreeze your deal at the lower rate. No card details required."
  },
  // CTAs unique to the advice panel
  priceInsightsAdviceViewFreezableDeals: {
    id: 'priceInsightsAdviceViewFreezableDeals',
    defaultMessage: 'View freezable deals'
  },
  priceInsightsAdviceViewAlternatives: {
    id: 'priceInsightsAdviceViewAlternatives',
    defaultMessage: 'View alternatives'
  },
  // Loading state for the better-value carousel (Consider alternatives)
  priceInsightsAdviceCarouselLoading: {
    id: 'priceInsightsAdviceCarouselLoading',
    defaultMessage: 'Checking for better deals…'
  }
})

export type PriceTrendMessageKey = keyof typeof priceTrendMessages
